.form {
    contain: inline-size;
}
